interface updateMatchResultOfCategoryOthersProps {
  matchElement: HTMLElement;
  result?: string;
}

/**
 * Funkce pro aktualizaci výsledku ze sport kategorie ostatní po skončení zápasu.
 * Zvyraznění vítěze zápasu.
 *
 * @param {HTMLElement} matchElement - HTMLElement - zápas/událost, který má být aktualizován. Obashuje HTMLElement s data atributem 'data-match-overview-result-category-others'
 * @param {string} result - Výsledek zápasu/události.
 */
export const updateMatchResultOfCategoryOthers = ({
  matchElement,
  result,
}: updateMatchResultOfCategoryOthersProps): void => {
  if (!matchElement || !result) return;

  const matchResultElement = matchElement.querySelector<HTMLElement>(
    '[data-match-overview-result-category-others]'
  );

  if (!matchResultElement) return;

  // Pokud výsledku obsahuje slovo "Vítěz", odstraní se v něm prvních 7 znaků (předpokládá se formát "Vítěz: Jméno").
  // Pokud výsledku není k dispozici, přiřadí se k němu prázdný řetězec.
  const matchResult = result?.includes('Vítěz') ? result.slice(7) : result || '';

  matchResultElement.classList.add('match-overview__event-result--winner');
  matchResultElement.textContent = `Vítěz ${matchResult}`;
};
